import AsyncStorage from '@react-native-async-storage/async-storage';
import { StackActions } from '@react-navigation/native';
import * as React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { NavigationRoute, NavigationScreenProp } from 'react-navigation';
import { useQuery } from 'react-query';
import { getUser } from '../services/ApiService';

export interface ISplashScreenProps {
    navigation: NavigationScreenProp<NavigationRoute>;
}

const quotes = [
    "Satu-satunya cara untuk mencapai karya besar adalah dengan mencintai apa yang Anda kerjakan.",
    "Percayalah bahwa Anda bisa dan Anda sudah setengah jalan.",
    "Kesuksesan bukanlah akhir, kegagalan bukanlah fatal: yang penting adalah keberanian untuk terus berjuang.",
    "Tidak peduli seberapa lambat Anda bergerak selama Anda tidak berhenti.",
    "Kesuksesan adalah jumlah usaha kecil yang diulang setiap hari.",
    "Satu-satunya batasan untuk kesadaran kita tentang hari esok adalah keraguan kita tentang hari ini.",
    "Satu-satunya cara untuk mencapai karya besar adalah dengan mencintai apa yang Anda kerjakan.",
    "Kehormatan terbesar dalam hidup adalah tidak pernah jatuh, tapi bangkit setiap kali kita jatuh.",
    "Satu-satunya batasan untuk kesadaran kita tentang hari esok adalah keraguan kita tentang hari ini.",
    "Pekerjaan Anda akan mengisi sebagian besar dari hidup Anda, dan satu-satunya cara untuk benar-benar puas adalah melakukan apa yang Anda anggap sebagai karya besar. Dan satu-satunya cara untuk melakukan karya besar adalah dengan mencintai apa yang Anda kerjakan.",
    "Pikiran positif akan membuat Anda melakukan segala sesuatu dengan lebih baik daripada pikiran negatif.",
    "Petualangan terbesar yang bisa Anda ambil adalah hidup sesuai dengan impian Anda.",
    "Satu-satunya batasan untuk kesadaran kita tentang hari esok adalah keraguan kita tentang hari ini.",
    "Jangan melihat jam; lakukan apa yang dilakukan jam. Terus bergerak.",
    "Kesuksesan bukanlah kunci dari kebahagiaan. Kebahagiaan adalah kunci dari kesuksesan. Jika Anda mencintai apa yang Anda lakukan, Anda akan sukses.",
];

export function SplashScreen({ navigation }: ISplashScreenProps) {

    const { data, isFetching, isError } = useQuery('user', async () => {
        const token = await AsyncStorage.getItem('token');
        return await getUser(token?.toString() ?? '');
    }, { retry: false });

    React.useEffect(() => {
        if (isError) {
            navigation.dispatch(
                StackActions.replace('Login', {})
            );
        }
        if (data?.id) {
            navigation.dispatch(
                StackActions.replace('Home', {})
            );
        }
    }, [isError, data]);

    return (
        <View style={styles.container}>
            <Text style={styles.text}>{quotes[Math.floor(Math.random() * quotes.length)]}</Text>
            <Text>{isFetching ? 'Loading...' : ''}</Text>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
    },
    text: {
        fontSize: 20,
        justifyContent: 'center',
    }
});
